import { RefObject, useContext } from 'react';
import { IconButton } from '@mui/material';
import SendIcon from '@mui/icons-material/SendTwoTone';
import { GridApiContext, GridApiPro, gridRowSelectionIdsSelector } from '@mui/x-data-grid-pro';
import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { openPickupDeliveryReceipts } from '@components/DataGrid/Dispatch/Actions/PrintPickupDeliveryReceipts';
import { queueModal } from '@components/Modals/modalSlice';
import { useAppDispatch } from '@reduxStore';
import { SendPudlReceiptProps } from '@/PickupDeliveryReceipt/types';

import styles from './ApplicationLink.module.css';

/**
 * Component for rendering a Send Pickup/Delivery Receipt Modal link.
 */
export default function SendDeliveryReceiptLink(props: SendPudlReceiptProps) {
  const appDispatch = useAppDispatch();
  // Read directly rather than with useGridApiContext, which throws when the link is rendered outside a grid (e.g. the leg form)
  const gridApiRef = useContext(GridApiContext) as RefObject<GridApiPro> | undefined;

  const handleBtnClick = () => {
    // Read at click time rather than subscribing so every link on the board does not re-render on selection changes
    const selectedLegs = gridApiRef ? (Array.from(gridRowSelectionIdsSelector(gridApiRef).values()) as DispatchLeg[]) : [];

    if (selectedLegs.length > 1 && selectedLegs.some((leg) => leg.legId === props.legId)) {
      // This leg is part of a multi-row selection, so send the receipts for the whole selection, the same as the action menu does
      openPickupDeliveryReceipts(appDispatch, selectedLegs);
    } else {
      appDispatch(
        queueModal({
          Component: 'sendPudlReceiptModal',
          Props: props
        })
      );
    }
  };

  return (
    <IconButton
      className={styles['icon-btn']}
      onClick={handleBtnClick}>
      <SendIcon fontSize='inherit' />
    </IconButton>
  );
}
